import React from 'react';
import Icon from '../../../components/AppIcon';
import { IntegrationFeature } from '../types';

const IntegrationFeatures: React.FC = () => {
  const features: IntegrationFeature[] = [
    {
      id: '1',
      icon: 'Zap',
      title: 'Real-Time Data Sync',
      description: 'Bi-directional data synchronization across platforms with sub-second latency and automatic conflict resolution.'
    },
    {
      id: '2',
      icon: 'Shield',
      title: 'Enterprise Security',
      description: 'Bank-level encryption, OAuth 2.0 authentication, and compliance with SOC 2, GDPR, and HIPAA standards.'
    },
    {
      id: '3',
      icon: 'TrendingUp',
      title: 'Scalable Architecture',
      description: 'Built to handle millions of API calls daily with auto-scaling infrastructure and load balancing.'
    },
    {
      id: '4',
      icon: 'GitBranch',
      title: 'Version Control',
      description: 'Comprehensive API versioning with backward compatibility and seamless migration paths.'
    },
    {
      id: '5',
      icon: 'AlertCircle',
      title: 'Error Handling',
      description: 'Intelligent retry mechanisms, detailed error logging, and automated failure notifications.'
    },
    {
      id: '6',
      icon: 'FileCode',
      title: 'Custom Endpoints',
      description: 'Tailored API endpoints designed specifically for your business logic and data requirements.'
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-text-primary mb-4">
            Enterprise-Grade Integration Features
          </h2>
          <p className="text-lg text-text-secondary">
            Built with the technical excellence and reliability your business demands
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {features.map((feature) => (
            <div 
              key={feature.id}
              className="bg-card p-6 rounded-lg border border-border hover:border-primary hover:shadow-lg transition-all duration-fast group"
            >
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-primary group-hover:scale-110 transition-all duration-fast">
                <Icon name={feature.icon} size={24} className="text-primary group-hover:text-white" />
              </div>
              <h3 className="text-xl font-semibold text-text-primary mb-3">
                {feature.title}
              </h3>
              <p className="text-text-secondary leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IntegrationFeatures;